// Generated by `artisan app:generate-custom-typescript` from VariableType. Do not edit.

/** The stored field type of each `field.<builder>` of @diagonal-hq/cli. */
export const FIELD_BUILDER_TYPES = {
  boolean: 'boolean',
  color: 'color',
  content: 'content',
  date: 'date',
  datetime: 'datetime',
  dictionary: 'dictionary',
  email: 'email',
  eventSchedule: 'event_schedule',
  file: 'file_reference',
  fileReference: 'file_reference',
  liquid: 'liquid',
  list: 'list',
  location: 'location',
  longText: 'text',
  markdown: 'markdown',
  money: 'money',
  number: 'number',
  password: 'password',
  phone: 'phone',
  recurrence: 'recurrence',
  regularHours: 'regular_hours',
  relation: 'relation',
  resourceReference: 'resource_reference',
  select: 'select',
  text: 'text',
  time: 'time',
  timezone: 'timezone',
  url: 'url',
  uuid: 'uuid',
  walletAccountingAccount: 'wallet_accounting_account',
  walletAccountingEntity: 'wallet_accounting_entity',
} as const;
